import React, { useState } from 'react';
import './Questions.css';
import plusIcon from '../../assets/icons/plus.png';
import minusIcon from '../../assets/icons/minus.png';

const Questions = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const questionsData = [
    {
      id: 1,
      question: "How long does it take to prepare and lodge a tax return?",
      answer: "Preparing a simple tax return takes around 30–60 minutes. Once lodged, the ATO usually processes it within 2 weeks."
    },
    {
      id: 2,
      question: "What documents do I need to provide?",
      answer: "You’ll need your PAYG summaries, bank statements, private health insurance, deductions, and super contributions. Also        include investment income or business records, if applicable."
    },
    {
      id: 3,
      question: "Are your fees tax-deductible?",
      answer: "Yes, PFGS service fees are tax‑deductible."
    },
    {
      id: 4,
      question: "Can you help if I missed previous years' returns?",
      answer: "Yes — PFGS can assist you with lodging any missed tax returns from previous years through their services as registered tax agents in Australia."
    },
    {
      id: 5,
      question: "Do I need to visit your office in person?",
      answer: "You do not need to visit PFGS’s office in person to prepare or lodge your tax return. PFGS offers fully online, end-to-end tax return services"
    }
  ];

  const toggleQuestion = (questionId) => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };

  return (
    <section className="questions">
      <div className="questions-container">
        <div className="questions-content">
          <div className="questions-tag">FAQ's</div>

          <h2 className="questions-title">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>

          <p className="questions-description">
            Have questions? We've answered some of the most common ones below. If you still need help, feel free to contact us anytime.
          </p>

          <div className="questions-cards">
            {questionsData.map((item) => (
              <div
                key={item.id}
                className={`question-card ${openQuestion === item.id ? 'open' : ''}`}
                onClick={() => toggleQuestion(item.id)}
              >
                <div className="question-header">
                  <h3 className="question-text">{item.question}</h3>
                  <img
                    src={openQuestion === item.id ? minusIcon : plusIcon}
                    alt={openQuestion === item.id ? "Collapse" : "Expand"}
                    className="toggle-icon"
                  />
                </div>
                {openQuestion === item.id && (
                  <div className="question-answer">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Questions;
